import { z } from 'zod';

export const POSITION_REVIEWER_TOOL_ID = 'set_position_reviewer';
export const POSITION_APPROVAL_TOOL_ID = 'set_position_approval';
export const POSITION_PUBLICATION_TOOL_ID = 'set_position_publication';

export const POSITION_STATE_TOOL_IDS = [
    POSITION_REVIEWER_TOOL_ID,
    POSITION_APPROVAL_TOOL_ID,
    POSITION_PUBLICATION_TOOL_ID,
] as const;

const positionBulkRunReasonSchema = z.object({
    kind: z.string().nullish(),
    code: z.string().nullish(),
    message: z.string().nullish(),
});

const positionBulkRunItemSchema = z.object({
    positionId: z.string().nullish(),
    title: z.string().nullish(),
    status: z.string().nullish(),
    reason: positionBulkRunReasonSchema.nullish(),
});

export type PositionBulkRunItem = z.infer<typeof positionBulkRunItemSchema>;

/**
 * Progress and result of one reviewer, approval or publication run over a filtered set of
 * positions. Every emission of a run carries the same `blockId`, so the latest one is the state of
 * the run, and the run ends within the turn that started it. Action and status stay strings: a
 * value this client does not know must not drop the card.
 */
export const positionBulkRunProgressBlockSchema = z.object({
    type: z.literal('position-bulk-run-progress'),
    blockId: z.string(),
    architectureId: z.string().nullish(),
    action: z.string().nullish(),
    status: z.string().nullish(),
    total: z.number().nullish(),
    done: z.number().nullish(),
    succeeded: z.number().nullish(),
    failed: z.number().nullish(),
    skipped: z.number().nullish(),
    items: z.array(positionBulkRunItemSchema).nullish(),
    itemsTruncated: z.boolean().nullish(),
});

export type PositionBulkRunProgressBlock = z.infer<typeof positionBulkRunProgressBlockSchema>;
